/**
 * @author: ritesh.dabral
 * 
 * This page imports all constants, and creates required function
 * 
 */

 import { 
   UPDATE_CURRENT_IMAGE, 
   UPDATE_CURRENT_IMAGE_REF,
   ADD_HOTSPOT,
   UPDATE_HOTSPOT,
   DELETE_HOTSPOT, 
   //INCREASE_HOTSPOT_COUNT,
   UPDATE_CURRENT_HOTSPOT_ID,
   UPDATE_CURRENT_HOTSPOT_OBJ,
   UPDATE_WHOLE_HOTSPOT_MAP_OBJECT,
   SYNC_HOTSPOT_TITLE_DESC_URL,
   UPDATE_WHOLE_SYNC_HOTSPOT_TITLE_DESC_URL,
   UPDATE_PROJECTID_AND_SKUID
  } from './HotspotEditActionType'
 

 export const updateCurrentImage = (currentImageData) => {
    return {
        type: UPDATE_CURRENT_IMAGE,
        payload: currentImageData,
        info: 'HotspotEdit Component - UpdateCurrentImage ActionController'
    }
 } 

 export const updateCurrentImageRef = (currentImageRef) => {
    return {
      type: UPDATE_CURRENT_IMAGE_REF,
      payload: currentImageRef,
      info: 'HotspotEdit Component - UpdateCurrentImageRef ActionController'  
    }
 }

 export const addHotspot = (newHotspot, imageId='') => {
    return {
     type: ADD_HOTSPOT,
     payload: {newHotspot,imageId},
     info: 'HotspotEdit Component - AddNewHotspot for an imageId ActionController'
    }
 }

 export const updateHotspot = (updatedHotspot, imageId) => {
    return {
      type: UPDATE_HOTSPOT,
      payload: {updatedHotspot,imageId},
      info: 'HotspotEdit Component - UpdateOldHotspot for an imageId ActionController'
    }
  }

  export const deleteHotspot = (oldHotspotId, imageId) => {
    return {
      type: DELETE_HOTSPOT,
      payload: {oldHotspotId,imageId},
      info: 'HotspotEdit Component - DeleteOldHotspot for an imageId ActionController'
    }
  }

  // export const updateHotspotCount = (oldCount) => {
  //   return {
  //     type: INCREASE_HOTSPOT_COUNT,
  //     payload: oldCount,
  //     info: 'HotspotEdit Component - UpdateHotspotCount for an image index ActionController'
  //   }
  // }

  export const updateCurrentHotSpotId = (hotSoptId) => {
    return {
      type: UPDATE_CURRENT_HOTSPOT_ID,
      payload: hotSoptId,
      info: 'HotspotEdit Component - updateCurrentHotSpotId for an image hotspot ActionController'
    }
  }

  export const updateCurrentHotSpotObj = (hotSpotObj) => {
    return {
      type: UPDATE_CURRENT_HOTSPOT_OBJ,
      payload: hotSpotObj,
      info: 'HotspotEdit Component - updateCurrentHotSpotObj for a hotspot ActionController'
    }
  }

  export const updateWholeHotSpotMapObj = (newHotSpotMapObj)=>{
    return {
      type: UPDATE_WHOLE_HOTSPOT_MAP_OBJECT,
      payload: newHotSpotMapObj,
      info: 'HotspotEdit Component - updateWholeHotSpotMapObj for entire hotspot ActionController'
    }
  }

  export const upateSyncHotSpotTitleDescURL = (hotSpotId, titleDescURL)=>{
    return {
      type: SYNC_HOTSPOT_TITLE_DESC_URL,
      payload: {hotSpotId, titleDescURL},
      info: `HotspotEdit Component - syncHotSpotTitleDescURL for entire hotspot ActionController.
      titleDescURL = {
        'title':'', 'desc':'','url':''
      }
      `
    }
  }

  export const updateWholeSyncHotSpotTitleDescURL = (syncHotSpotTitleDescURL) => {
    return {
      type: UPDATE_WHOLE_SYNC_HOTSPOT_TITLE_DESC_URL,
      payload: syncHotSpotTitleDescURL,
      info: 'HotspotEdit Component - updateWholeSyncHotSpotTitleDescURL for entire syncHotSpotTitleDescURL ActionController'
    }
  }

  export const updateProjectIdAndSkuId = (projectId,skuId)=>{
    return {
      type: UPDATE_PROJECTID_AND_SKUID,
      payload: {projectId,skuId},
      info: 'HotspotEdit Component - updateProjectIdAndSkuId for entire Hotspot ActionController'
    }
  }

 // exports
 const hotspotActionControllers = {
   updateCurrentImage,
   updateCurrentImageRef,
   addHotspot,
   updateHotspot,
   deleteHotspot,
   //updateHotspotCount,
   updateCurrentHotSpotId,
   updateCurrentHotSpotObj,
   updateWholeHotSpotMapObj,
   upateSyncHotSpotTitleDescURL,
   updateWholeSyncHotSpotTitleDescURL,
   updateProjectIdAndSkuId
 }
 
 export default hotspotActionControllers;